export class DumpsterFireReelSet {
    public static DEFAULT_REEL_SET: string[][] = [
        ["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5"],
        ["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5"],
        ["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5"],
        ["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5"],
        ["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5"],
        ["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5"],
        ["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5"]
    ];
}